<template>
<main>
    <div class="container margin_30">
        <div class="page_header">
            <div class="breadcrumbs">
                <ul>
                    <li>Terms and Conditions</li>
                </ul>
            </div>
            <h2><strong>Terms and Conditions</strong></h2>
        </div>

        <div>
            <p>Welcome to Edutech Institute!</p>
            <p>These terms and conditions outline the rules and regulations for the use of Edutech Institute’s platform, located at 
                <a href="https://edutechapp.dktechs.in/">https://edutechapp.dktechs.in/</a>.
            </p>
            <p>By accessing and using this platform, we assume you accept these terms and conditions. Do not continue to use Edutech Institute if you do not agree to all of the terms and conditions stated on this page.</p>

            <p>
                The following terminology applies to these Terms and Conditions, Privacy Policy, Disclaimer Notice, and all Agreements: 
                “Student”, “Learner”, “You” and “Your” refers to you, the person logging on to this platform and compliant with the Company’s terms. 
                “The Company”, “Our Institution”, “We”, “Our” and “Us”, refers to Edutech Institute. 
                “Instructor”, “Educator”, or “Trainer” refers to authorized individuals providing educational content. 
                “Party”, “Parties”, or “Us”, refers to both the Student and Edutech Institute. 
            </p>

            <h3><strong>Cookies</strong></h3>
            <p>We employ the use of cookies. By accessing Edutech Institute, you agreed to use cookies in accordance with Edutech Institute’s Privacy Policy.</p>
            <p>Cookies are used to enhance learning experiences, save login details, and provide personalized recommendations. Some third-party integrations (e.g., analytics, video hosting) may also use cookies.</p>

            <h3><strong>License</strong></h3>
            <p>Unless otherwise stated, Edutech Institute and/or its licensors own the intellectual property rights for all educational content, videos, assessments, and resources on the platform. All intellectual property rights are reserved.</p>
            <p>You may access the platform for your own personal learning use, subject to restrictions set in these terms.</p>
            <p>You must not:</p>
            <ul>
                <li>Republish platform content without proper authorization;</li>
                <li>Sell, rent, or sub-license platform material;</li>
                <li>Reproduce or duplicate course content for commercial purposes;</li>
                <li>Redistribute content without explicit permission.</li>
            </ul>
            <p>This Agreement shall begin on the date of your first access to Edutech Institute.</p>

            <h3><strong>User-Generated Content</strong></h3>
            <p>Students and instructors may post questions, comments, assignments, or other content in discussion forums or interactive areas. Such content does not represent the views of Edutech Institute.</p>
            <p>Edutech Institute reserves the right to moderate, remove, or restrict content that is inappropriate, offensive, or in violation of these terms.</p>
            <p>You warrant and represent that your submissions:</p>
            <ul>
                <li>Are your own original work or you have rights to share them;</li>
                <li>Do not infringe on intellectual property rights of others;</li>
                <li>Do not contain offensive, defamatory, or unlawful material;</li>
                <li>Will not be used to promote unauthorized commercial activities.</li>
            </ul>

            <h3><strong>Hyperlinking to our Platform</strong></h3>
            <p>Certain institutions, schools, government agencies, and academic partners may link to our platform without prior approval if it supports educational objectives.</p>

            <h3><strong>iFrames</strong></h3>
            <p>Without prior written permission, you may not create frames or embed Edutech Institute content on external platforms in a way that misrepresents ownership or disrupts presentation.</p>

            <h3><strong>Content Liability</strong></h3>
            <p>We are not responsible for external links, third-party content, or user submissions. Users are responsible for ensuring that their shared content complies with academic and legal standards.</p>

            <h3><strong>Reservation of Rights</strong></h3>
            <p>We reserve the right to modify or update these Terms and Conditions at any time. Continued use of Edutech Institute after updates implies acceptance of the revised terms.</p>

            <h3><strong>Disclaimer</strong></h3>
            <p>To the maximum extent permitted by applicable law, Edutech Institute provides learning content “as is,” without warranties of accuracy, completeness, or uninterrupted availability.</p>
            <ul>
                <li>We do not guarantee specific learning outcomes;</li>
                <li>We are not liable for any academic, professional, or personal losses resulting from use of the platform;</li>
                <li>Instructors are responsible for the accuracy of their provided course material.</li>
            </ul>
            <p>As long as the platform and its resources are provided free of charge (or under subscription terms), Edutech Institute will not be liable for any direct or indirect damages.</p>



                <h2>Governing Law and Dispute Resolution</h2>
              <p>All disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in Solapur and Maharashtra.</p>

        </div>
                         <router-link to="/" class="btn btn-primary mt-1 mb-1">
                                Go to Home
                                </router-link>
    </div>
</main>
</template>
